import {
    HAPIACA_ACCEPT_CALLBACK_URLS,
    HAPIACA_CONFIRM_COMPONENT,
    HAPIACA_DEFAULT_CALLBACK_URL,
    HAPIACA_EMAIL_DOMAINS,
    HAPIACA_LINKAGE_ID,
    HAPIACA_LINKAGE_NAME,
    HAPIACA_PATH,
    HAPIACA_PROFILE_COMPONENT,
    HAPIACA_SERVICE_TERM_URL,
    HAPIACA_SITE_UNIQ_API_PATH
} from "@/commons/linkage/sites/hapiaca";
import { createLinkageRoute, linkageBeforeEach, linkageScrollBehavior } from "@/router/linkage";
import { createRouter, createWebHistory, NavigationGuardNext, RouteLocationNormalized, RouteRecordRaw } from "vue-router";
import { LinkageRouteNames } from "@/commons/linkage/linkageCommon";
import LinkageMailMagazine from "@/views/Linkage/User/LinkageMailMagazine.vue";
import LinkageMailMagazineConfirm from "@/views/Linkage/User/LinkageMailMagazineConfirm.vue";
import LinkageMailMagazineComplete from "@/views/Linkage/User/LinkageMailMagazineComplete.vue";
import LinkageMailMagazineRescueProfile from "@/views/Linkage/User/LinkageMailMagazineRescueProfile.vue";
import LinkageMailMagazineRescueProfileConfirm from "@/views/Linkage/User/LinkageMailMagazineRescueProfileConfirm.vue";

// ハピアカ画面用ルート定義
const routes = createLinkageRoute(
    HAPIACA_LINKAGE_ID,
    HAPIACA_LINKAGE_NAME,
    HAPIACA_PATH,
    HAPIACA_SITE_UNIQ_API_PATH,
    HAPIACA_DEFAULT_CALLBACK_URL,
    HAPIACA_ACCEPT_CALLBACK_URLS,
    HAPIACA_SERVICE_TERM_URL,
    HAPIACA_EMAIL_DOMAINS,
    HAPIACA_PROFILE_COMPONENT,
    HAPIACA_CONFIRM_COMPONENT,
    {
        disableSignup: true
    }
);

// ハピアカ用メールマガジン画面定義
const RouteNames = new LinkageRouteNames(HAPIACA_LINKAGE_ID, HAPIACA_LINKAGE_NAME);
const mailMagazineViews = [
    {
        path: "mail_magazine",
        name: RouteNames.MAIL_MAGAZINE,
        component: LinkageMailMagazine,
        meta: { title: "メールマガジン購読" },
    },
    {
        path: "mail_magazine_confirm",
        name: RouteNames.MAIL_MAGAZINE_CONFIRM,
        component: LinkageMailMagazineConfirm,
        meta: { title: "メールマガジン購読(変更確認)" },
    },
    {
        path: "mail_magazine_complete",
        name: RouteNames.MAIL_MAGAZINE_COMPLETE,
        component: LinkageMailMagazineComplete,
        meta: { title: "メールマガジン購読(変更完了)" },
    },
    {
        path: "mail_magazine/rescue_profile",
        name: RouteNames.MAIL_MAGAZINE_RESCUE_PROFILE,
        component: LinkageMailMagazineRescueProfile,
        meta: { title: "会員情報変更" },
        props: true,
        children: [
            {
                path: "",
                name: `${RouteNames.MAIL_MAGAZINE_RESCUE_PROFILE}Child`,
                component: HAPIACA_PROFILE_COMPONENT,
                props: { nextRoute: `${RouteNames.MAIL_MAGAZINE_RESCUE_PROFILE_CONFIRM}Child` }
            }
        ]
    },
    {
        path: "mail_magazine/rescue_profile_confirm",
        name: RouteNames.MAIL_MAGAZINE_RESCUE_PROFILE_CONFIRM,
        component: LinkageMailMagazineRescueProfileConfirm,
        meta: { title: "会員情報変更(確認)" },

        beforeEnter: (to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext) => {
            if (!from.name) {
                next({ name: `${RouteNames.MAIL_MAGAZINE_RESCUE_PROFILE}Child` });
            } else {
                next();
            }
        },
        children: [
            {
                path: "",
                name: `${RouteNames.MAIL_MAGAZINE_RESCUE_PROFILE_CONFIRM}Child`,
                component: HAPIACA_CONFIRM_COMPONENT,
                props: { prevRoute: `${RouteNames.MAIL_MAGAZINE_RESCUE_PROFILE}Child`, nextRoute: RouteNames.PROFILE_COMPLETE }
            }
        ]
    },
];

// RouteNames.USER_PARENTのルート定義を検索
const findUserParent = (routes: RouteRecordRaw[]): RouteRecordRaw | undefined => {
    let found = routes.find(r => r.name === RouteNames.USER_PARENT);
    if (!found) {
        found = findUserParent(routes.filter(r => r.children).flatMap(r => r.children) as RouteRecordRaw[]);
    }
    return found;
};
// RouteNames.USER_PARENTにメルマガ関連画面定義をマージ
const userParentRoute = findUserParent(routes);
userParentRoute?.children?.push(...mailMagazineViews);

// ハピアカ画面用ルータ作成
const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    scrollBehavior: linkageScrollBehavior,
    routes: routes,
});

// beforeEach
router.beforeEach(linkageBeforeEach);

// ハピアカ画面用ルータ
export const hapiacaRouter = router;
